/**
 * Initialize the "How You Heard About Us" step with proper event handlers
 * for the multi-level selection (primary source -> secondary details -> other specification).
 */
function initializeHowYouHeardAboutUs() {
	const sourceTypeSelect = this.currentStepElement.querySelector('[data-source-type-select]');
	const detailGroups = this.currentStepElement.querySelectorAll('[data-detail-group]');
	const otherSpecificationInput = this.currentStepElement.querySelector('[data-other-specification]');

	if (!sourceTypeSelect) {
		return;
	}

	// Handle primary source type selection
	sourceTypeSelect.addEventListener('change', (event) => {
		const selectedValue = event.target.value;

		// Hide all detail groups and disable their inputs
		detailGroups.forEach((group) => {
			group.classList.add('js-hide', 'invisible');
			group.querySelectorAll('input').forEach((input) => {
				input.disabled = true;
				if (input.type === 'radio') {
					input.checked = false;
				} else {
					input.value = '';
				}
			});
		});

		// Hide and clear the other specification input
		if (otherSpecificationInput) {
			otherSpecificationInput.classList.add('js-hide', 'invisible');
			otherSpecificationInput.querySelectorAll('input').forEach((input) => {
				input.disabled = true;
				input.value = '';
			});
		}

		// Show the matching detail group
		if (selectedValue) {
			const matchingGroup = this.currentStepElement.querySelector(`[data-detail-group="${selectedValue}"]`);
			if (matchingGroup) {
				matchingGroup.classList.remove('js-hide', 'invisible');
				matchingGroup.querySelectorAll('input').forEach((input) => {
					input.disabled = false;
				});

				// If this source always requires specification, show the text input immediately
				if (matchingGroup.dataset.requiresOtherSpec === 'true' && otherSpecificationInput) {
					otherSpecificationInput.classList.remove('js-hide', 'invisible');
					otherSpecificationInput.querySelectorAll('input').forEach((input) => {
						input.disabled = false;
					});
				}
			}
		}

	});

	// Handle secondary detail selection (radio buttons and text inputs)
	detailGroups.forEach((group) => {
		const requiresOtherSpec = group.dataset.requiresOtherSpec === 'true';
		const radios = group.querySelectorAll('input[type="radio"]');

		radios.forEach((radio) => {
			radio.addEventListener('change', (event) => {
				if (!otherSpecificationInput) {
					return;
				}

				const selectedValue = event.target.value;
				const isOther = selectedValue === 'Other';

				// Show other specification if "Other" is selected, or if this source type
				// always requires specification (like Word of Mouth)
				if (isOther || requiresOtherSpec) {
					otherSpecificationInput.classList.remove('js-hide', 'invisible');
					otherSpecificationInput.querySelectorAll('input').forEach((input) => {
						input.disabled = false;
					});
				} else {
					otherSpecificationInput.classList.add('js-hide', 'invisible');
					otherSpecificationInput.querySelectorAll('input').forEach((input) => {
						input.disabled = true;
						input.value = '';
					});
				}
			});
		});
	});
}

export {
	initializeHowYouHeardAboutUs
}
